import './cookieConsent';

var cookiePadding = function(){

    var footer = document.querySelector("footer");
    var popUp = document.querySelector(".cc-window");
    var popUpHeight = popUp.offsetHeight;

    footer.style.paddingBottom=popUpHeight + "px";

    if(popUp.classList.contains('cc-invisible')){
        footer.style.paddingBottom="0";
    }

}
window.addEventListener("load", function(){
    window.addEventListener("scroll", cookiePadding, false);
    window.addEventListener("load", cookiePadding, false);
    window.addEventListener("resize", cookiePadding, false);
});

window.addEventListener("load", function(){

    window.cookieconsent.initialise({
        position: "bottom",   
        theme: "classic",
        
        onPopupOpen : function () {

            // prevent notice from 'floating' on mobiles/tablets

            document.querySelector(".cc-window").classList.remove("cc-floating");
            document.querySelector(".cc-window").classList.add("cc-banner");


            // add padding to footer
            var footer = document.querySelector("footer");
            var popUp = document.querySelector(".cc-window");
            var popUpHeight = popUp.offsetHeight;
        
            footer.style.paddingBottom=popUpHeight + "px";           
        },
        onPopupClose : function () {

            // remove padding from footer
            var footer = document.querySelector("footer");
        
            footer.style.paddingBottom="0";
        },                
        "content": {
            "message": "This website uses cookies to give you the best experience. By using our website you agree to our cookie policy",
            "dismiss": "<span>Accept &amp; Close</span>",
            "link": "Learn more",
            "href": "/cookies"
        }        
    })
});



